/** Shared text colours for input fields, keyed by field state rather than by colour. */
export const activeTextClasses = "text-col-text-primary"
export const inactiveTextClasses = "text-col-text-secondary"
export const errorTextClasses = "text-col-text-alert"

/** Typed value: primary when the field has a value, secondary when empty. Errors do not change this. */
export const fieldValueTextClasses = (hasValue: boolean): string =>
    hasValue ? activeTextClasses : inactiveTextClasses
